import React from 'react';
import PropTypes from 'prop-types';
import { Working } from '../Icons';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import css from './WorkingSpinner.css';

function WorkingSpinner(props) {
  const { active, ...otherProps } = props;

  let classnames = [css.WorkingSpinner];
  if (active) {
    classnames.push(css.activeSpinner);
  }

  return (
    <div className={classnames.join(' ')}>
      <Working {...otherProps} />
    </div>
  );
}

export default withStyles(css)(WorkingSpinner);



// WEBPACK FOOTER //
// ./src/components/Button/WorkingSpinner.js